;(function ($) {

  $(document).ready(function () {
    $('body').on('click', '[data-submenu-toggle]', showHideToggle);
  });

  /**
   * Show/Hide Accordion Toggle.
   */
  function showHideToggle() {
    // console.log('showHideToggle');
    let $this = $(this),
      buttonText = $this.find('span'),
      $thisControlsID = $this.attr('aria-controls'),
      content = $('#' + $thisControlsID);

    if (content.hasClass('open')) {
      // console.log('close toggle');
      content.removeClass('open');
      $this.removeClass('up-arrow');
      buttonText.html('open submenu');
      content.attr('aria-hidden', true);
      $this.attr('aria-expanded', false);
    } else {
      // console.log('open toggle');
      content.addClass('open');
      $this.addClass('up-arrow');
      buttonText.html('close submenu');
      content.attr('aria-hidden', false);
      $this.attr('aria-expanded', true);
    }
  }

})(jQuery);
